import {BaseContainerModel} from "../../../base-container.model";
import {
    bl_alg_cc_task_event_RowClass,
    bl_alg_cc_task_ext_RowClass, 
    bl_alg_cc_task_hdr_RowClass, 
    bl_alg_cc_task_hdr_RowInterface

}from "../../../../dbschema"

export class TaskContainerModel extends BaseContainerModel{
    bl_alg_cc_task_hdr : bl_alg_cc_task_hdr_RowInterface = new bl_alg_cc_task_hdr_RowClass();
    bl_alg_cc_task_exts : bl_alg_cc_task_ext_RowClass[] = [];
    bl_alg_cc_task_events: bl_alg_cc_task_event_RowClass[] = [];
}